import { QueryClient } from '@tanstack/react-query'
import { CACHE_DEFAULT_STALE_TIME } from 'app.constants'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: CACHE_DEFAULT_STALE_TIME,
            refetchOnReconnect: 'always'
        }
    }
})
